//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({

  contentGrid: {
    textAlign: "center",
  },
  backBtn: {
    border: "none",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#0a72ba",
    }
  },
  checkIcon: {
    fontSize: 80,
    color: "green",
    verticalAlign: "middle",
  },
  content1: {
    fontSize: 25,
    fontWeight: "bold",
    padding: 30,
    textAlign: "center",
  },
  content2: {
    fontSize: 18,
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 20,
  },
}));
